/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ResponseQuestion = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        departmentId: {
    type: 'number',
},
        assignee: {
    type: 'number',
},
        question: {
    type: 'string',
    isRequired: true,
},
        alertDepartment: {
    type: 'boolean',
    isRequired: true,
},
        allowComment: {
    type: 'boolean',
    isRequired: true,
},
        allowFeedback: {
    type: 'boolean',
    isRequired: true,
},
        order: {
    type: 'number',
},
        ratingScore: {
    type: 'boolean',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
        updatedAt: {
    type: 'string',
},
    },
};